var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 54,
    viewBox: "0 0 178 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.625 54H6.5625C2.95477 54 0 50.9608 0 47.25V6.75C0 3.03919 2.95477 -9.53674e-07 6.5625 -9.53674e-07H170.625C174.233 -9.53674e-07 177.188 3.03919 177.188 6.75V47.25C177.188 50.9608 174.233 54 170.625 54Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6805 10.2345C13.3048 10.638 13.0874 11.2662 13.0874 12.0797V41.0982C13.0874 41.9117 13.3048 42.5399 13.6805 42.9434L13.7732 43.032L29.6212 26.7776V26.3938L13.7732 10.1393L13.6805 10.2345Z",
    fill: "url(#paint0_linear_560_904)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8979 32.1984L29.6211 26.7776V26.3937L34.9043 20.9729L35.0226 21.0434L41.2794 24.6961C43.0649 25.7327 43.0649 27.4386 41.2794 28.4817L35.0226 32.1279L34.8979 32.1984Z",
    fill: "url(#paint1_linear_560_904)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0232 32.128L29.6217 26.5857L13.6809 42.9435C14.274 43.5831 15.2411 43.6602 16.3409 43.0205L35.0232 32.128Z",
    fill: "url(#paint2_linear_560_904)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0232 21.0434L16.3409 10.1509C15.2411 9.51774 14.274 9.59483 13.6809 10.2345L29.6217 26.5857L35.0232 21.0434Z",
    fill: "url(#paint3_linear_560_904)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1789 13.6672C62.1789 14.7909 61.8531 15.6908 61.2113 16.362C60.4734 17.1576 59.5123 17.558 58.3345 17.558C57.2089 17.558 56.2478 17.1509 55.4594 16.3485C54.6694 15.5344 54.2751 14.5352 54.2751 13.3392C54.2751 12.1432 54.6694 11.1441 55.4594 10.3367C56.2478 9.52756 57.2089 9.12048 58.3345 9.12048C58.8949 9.12048 59.4292 9.23991 59.9391 9.46195C60.4473 9.68567 60.8611 9.98846 61.1608 10.3619L60.4799 11.0717C59.957 10.4342 59.2451 10.1197 58.3345 10.1197C57.5135 10.1197 56.8017 10.4157 56.1973 11.0129C55.5995 11.6117 55.2998 12.3872 55.2998 13.3392C55.2998 14.2913 55.5995 15.0735 56.1973 15.6723C56.8017 16.2628 57.5135 16.5655 58.3345 16.5655C59.206 16.5655 59.9391 16.2628 60.5173 15.6656C60.8985 15.2703 61.1152 14.7253 61.1722 14.0289H58.3345V13.0566H62.1202C62.1659 13.2669 62.1789 13.4704 62.1789 13.6672Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1848 10.2962H64.6288V12.853H67.8346V13.8253H64.6288V16.3821H68.1848V17.3729H63.6221V9.30542H68.1848V10.2962Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4232 17.3729H71.4165V10.2962H69.2354V9.30542H74.606V10.2962H72.4232V17.3729Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4927 17.3729V9.30542H79.4977V17.3729H78.4927Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.953 17.3729H82.9545V10.2962H80.7651V9.30542H86.1423V10.2962H83.953V17.3729Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3107 16.3351C95.5402 17.1509 94.5856 17.558 93.447 17.558C92.3018 17.558 91.3472 17.1509 90.5767 16.3351C89.8079 15.5209 89.425 14.5218 89.425 13.3392C89.425 12.1567 89.8079 11.1575 90.5767 10.3434C91.3472 9.52756 92.3018 9.12048 93.447 9.12048C94.5791 9.12048 95.5337 9.52756 96.3042 10.3501C97.0796 11.171 97.4624 12.1634 97.4624 13.3392C97.4624 14.5218 97.0796 15.5209 96.3107 16.3351ZM91.3212 15.6589C91.9011 16.2628 92.6064 16.5655 93.447 16.5655C94.281 16.5655 94.9929 16.2628 95.5663 15.6589C96.1445 15.055 96.4377 14.2795 96.4377 13.3392C96.4377 12.3989 96.1445 11.6235 95.5663 11.0196C94.9929 10.4157 94.281 10.1129 93.447 10.1129C92.6064 10.1129 91.9011 10.4157 91.3212 11.0196C90.7429 11.6235 90.4497 12.3989 90.4497 13.3392C90.4497 14.2795 90.7429 15.055 91.3212 15.6589Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8745 17.3729V9.30542H100.096L103.895 15.5797H103.939L103.895 14.0288V9.30542H104.9V17.3729H103.851L99.8731 10.789H99.8291L99.8731 12.3467V17.3729H98.8745Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1899 29.1864C86.1277 29.1864 83.6262 31.4003 83.6262 34.4548C83.6262 37.4846 86.1277 39.7216 89.1899 39.7216C92.2586 39.7216 94.7601 37.4846 94.7601 34.4548C94.7601 31.4003 92.2586 29.1864 89.1899 29.1864ZM89.1899 37.6471C87.5097 37.6471 86.0642 36.3296 86.0642 34.4548C86.0642 32.5552 87.5097 31.2609 89.1899 31.2609C90.8701 31.2609 92.3221 32.5552 92.3221 34.4548C92.3221 36.3296 90.8701 37.6471 89.1899 37.6471ZM77.0504 29.1864C73.9817 29.1864 71.4867 31.4003 71.4867 34.4548C71.4867 37.4846 73.9817 39.7216 77.0504 39.7216C80.1175 39.7216 82.6141 37.4846 82.6141 34.4548C82.6141 31.4003 80.1175 29.1864 77.0504 29.1864ZM77.0504 37.6471C75.3686 37.6471 73.9182 36.3296 73.9182 34.4548C73.9182 32.5552 75.3686 31.2609 77.0504 31.2609C78.7306 31.2609 80.1761 32.5552 80.1761 34.4548C80.1761 36.3296 78.7306 37.6471 77.0504 37.6471ZM62.6049 30.8011V33.0398H68.2322C68.0676 34.2907 67.6276 35.2103 66.9529 35.8512C66.1316 36.6253 64.8523 37.4845 62.6049 37.4845C59.1419 37.4845 56.4301 34.8294 56.4301 31.5396C56.4301 28.2497 59.1419 25.5946 62.6049 25.5946C64.4774 25.5946 65.8399 26.2898 66.8454 27.1908L68.506 25.6132C67.0996 24.3375 65.2287 23.3575 62.6049 23.3575C57.8561 23.3575 53.865 27.0282 53.865 31.5396C53.865 36.051 57.8561 39.7216 62.6049 39.7216C65.1717 39.7216 67.0996 38.9228 68.6152 37.4242C70.1683 35.9488 70.6523 33.8742 70.6523 32.1991C70.6523 31.6789 70.6067 31.2005 70.5252 30.8011H62.6049ZM121.674 32.5366C121.216 31.3585 119.803 29.1864 116.925 29.1864C114.073 29.1864 111.699 31.3213 111.699 34.4548C111.699 37.4056 114.049 39.7216 117.199 39.7216C119.746 39.7216 121.216 38.2462 121.821 37.387L119.93 36.1903C119.3 37.0665 118.441 37.6471 117.199 37.6471C115.965 37.6471 115.081 37.1099 114.513 36.051L121.93 33.1358L121.674 32.5366ZM114.113 34.2907C114.049 32.2595 115.773 31.2191 117.008 31.2191C117.977 31.2191 118.798 31.6789 119.072 32.3369L114.113 34.2907ZM108.084 39.4012H110.522V23.9195H108.084V39.4012ZM104.092 30.3599H104.01C103.463 29.7437 102.418 29.1864 101.095 29.1864C98.3177 29.1864 95.7787 31.5024 95.7787 34.4718C95.7787 37.4242 98.3177 39.7216 101.095 39.7216C102.418 39.7216 103.463 39.1597 104.01 38.5249H104.092V39.2804C104.092 41.2946 102.959 42.3768 101.132 42.3768C99.6426 42.3768 98.7186 41.355 98.3373 40.4957L96.2171 41.3364C96.8282 42.7328 98.4465 44.4513 101.132 44.4513C103.991 44.4513 106.403 42.8536 106.403 38.9661V29.5069H104.092V30.3599ZM101.303 37.6471C99.6231 37.6471 98.2167 36.311 98.2167 34.4718C98.2167 32.6156 99.6231 31.2609 101.303 31.2609C102.959 31.2609 104.264 32.6156 104.264 34.4718C104.264 36.311 102.959 37.6471 101.303 37.6471ZM133.089 23.9195H127.258V39.4012H129.689V33.5352H133.089C135.789 33.5352 138.437 31.6789 138.437 28.7266C138.437 25.7758 135.782 23.9195 133.089 23.9195ZM133.152 31.3817H129.689V26.073H133.152C134.968 26.073 136.004 27.5051 136.004 28.7266C136.004 29.9249 134.968 31.3817 133.152 31.3817ZM148.183 29.157C146.426 29.157 144.599 29.8939 143.848 31.5272L146.005 32.3864C146.47 31.5272 147.324 31.2485 148.227 31.2485C149.488 31.2485 150.767 31.9684 150.787 33.2395V33.402C150.347 33.1605 149.405 32.8029 148.246 32.8029C145.922 32.8029 143.554 34.0182 143.554 36.2863C143.554 38.3608 145.458 39.6969 147.598 39.6969C149.234 39.6969 150.137 38.9956 150.704 38.1797H150.787V39.3764H153.135V33.4376C153.135 30.6928 150.977 29.157 148.183 29.157ZM147.889 37.6409C147.094 37.6409 145.986 37.2663 145.986 36.3296C145.986 35.1313 147.368 34.6715 148.564 34.6715C149.635 34.6715 150.137 34.896 150.787 35.1917C150.596 36.6253 149.297 37.6409 147.889 37.6409ZM161.691 29.496L158.896 36.2073H158.813L155.924 29.496H153.301L157.643 38.8748L155.166 44.0937H157.706L164.396 29.496H161.691ZM139.773 39.4012H142.211V23.9195H139.773V39.4012Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_560_904",
    x1: 28.2141,
    y1: 41.4004,
    x2: 6.20017,
    y2: 19.9454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_560_904",
    x1: 43.6045,
    y1: 26.5838,
    x2: 12.6604,
    y2: 26.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_560_904",
    x1: 32.086,
    y1: 23.5728,
    x2: 2.2333,
    y2: -5.52183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_560_904",
    x1: 9.66828,
    y1: 52.5978,
    x2: 22.9989,
    y2: 39.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.f953760c0b47a8a91b5823ee8715188c.svg";
export { ForwardRef as ReactComponent };